import { IAPIResponse } from "../interfaces/api";
import { config } from "../utils/config";
import { log } from "../utils/logger";
import { formatURL } from "../utils/utils";

export const getRolesList = async <Type>(lanid: string): Promise<IAPIResponse<Type>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/role?userName=${lanid}`;
    const headers = new Headers();

    log.debug(`getRolesList HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}